import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { IconSC, IconSizes } from 'atoms/Icon'
import { ButtonGroupWrapper } from 'blocks/ButtonGroup'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { INDENTS } from 'vars/indents'
import { MEDIA } from 'vars/media'
import {
  PopupBottomBlockSC,
  PopupComponentSC,
  PopupFooterWrapperSC,
  PopupHeaderSC,
  PopupTopBlockSC,
} from '../PopupComponent.styled'

export const SignInToWatchPopupSC = styled.div`
  ${PopupComponentSC} {
    padding-top: var(${FIXED_INDENTS.INDENT_120});
    --popupWidth: 512px;
    --paddingLeft: var(${FIXED_INDENTS.INDENT_60});
    --paddingRight: var(${FIXED_INDENTS.INDENT_60});

    ${MEDIA.MIN_600} {
      padding-top: var(${FIXED_INDENTS.INDENT_140});
    }

    ${MEDIA.MIN_1240} {
      padding-top: var(${FIXED_INDENTS.INDENT_160});
      --paddingLeft: var(${FIXED_INDENTS.INDENT_120});
      --paddingRight: var(${FIXED_INDENTS.INDENT_120});
    }

    ${MEDIA.MIN_1920} {
      padding-top: var(${FIXED_INDENTS.INDENT_180});
      --paddingLeft: var(${FIXED_INDENTS.INDENT_160});
      --paddingRight: var(${FIXED_INDENTS.INDENT_160});
    }

    ${PopupTopBlockSC} {
      ${ButtonSC} {
        padding: var(${FIXED_INDENTS.INDENT_10});

        ${MEDIA.MIN_600} {
          padding: var(${FIXED_INDENTS.INDENT_20});
        }

        ${MEDIA.MIN_1920} {
          padding: var(${FIXED_INDENTS.INDENT_30});
        }

        ${IconSC} {
          font-size: ${IconSizes.xSm};

          ${MEDIA.MIN_1240} {
            font-size: ${IconSizes.xxMedium};
          }
        }
      }
    }

    ${PopupHeaderSC} {
      padding-bottom: 0;
    }

    ${PopupFooterWrapperSC} {
      padding-top: 0;
    }
  }

  ${ButtonGroupWrapper} {
    display: flex;

    ${ButtonSC} {
      flex: 1;
      padding: var(${INDENTS.INDENT_30}) var(${INDENTS.INDENT_60});
    }
  }

  ${PopupBottomBlockSC} {
    flex: 0 0 var(${FIXED_INDENTS.INDENT_60});

    ${MEDIA.MIN_1240} {
      flex: 0 0 var(${FIXED_INDENTS.INDENT_120});
    }

    ${MEDIA.MIN_1920} {
      flex: 0 0 var(${FIXED_INDENTS.INDENT_160});
    }
  }
`

export const SignInToWatchPopupBodySC = styled.div`
  height: var(${FIXED_INDENTS.INDENT_50});

  ${MEDIA.MIN_1240} {
    height: var(${FIXED_INDENTS.INDENT_60});
  }
`
